module.exports = __webpack_public_path__ + "img/img-header.e974fcc7.png";